import { authFetch } from '../AuthFetch';
import { createAction } from 'redux-actions';

export const forwardToSetMaintenanceTargetCase = createAction('SET_MAINTENANCE_TARGET_CASE');

export const forwardToSelectMcasesTab = createAction('SELECT_MAINTENANCE_CASES_TAB');

export const cleanAddCaseAlert = createAction('CLEAN_ADD_CASE_ALERT');

export const forwardChangeSelectedYear = createAction('CHANGE_SELECTED_YEAR');

export const forwardToAlertMCaseRequiredFields = () => (
  (dispatch) => {
    dispatch({
      type: 'ALERT_MAINTENENCE_CASE_REQUIRED_FIELDS',
      payload: null
    });
  }
);

export const forwardToAlertMCaseMessage = (message) => (
  (dispatch) => {
    dispatch({
      type: 'ALERT_MAINTENENCE_CASE_MESSAGE',
      payload: message
    });
  }
);

// export const forwardToSetMaintenanceCaseExported = (id) => (
//   (dispatch) => {
//     let request = {casePk: id, status: 'EXPORTED'};
//     let url = '/maintenance/mcases/'+id+'/status';
//     authFetch('POST', url, JSON.stringify(request), null);
//   }
// );

// export const forwardToSetMaintenanceCaseExported2 = (id) => (
//   (dispatch) => {
//     let request = {casePk: id, status: 'EXPORTED'};
//     let url = '/maintenance/mcases/'+id+'/status';
//     authFetch('POST', url, JSON.stringify(request), null);
//   }
// );

// export const forwardToSetMaintenanceCasePricePrinted = (id) => (
//   (dispatch) => {
//     let request = {casePk: id, status: 'PRICE_EXPORTED'};
//     let url = '/maintenance/mcases/'+id+'/status';
//     authFetch('POST', url, JSON.stringify(request), null);
//   }
// ); 

// export const forwardToSetMaintenanceCasePrinted = (id) => (
//   (dispatch) => {
//     let request = {casePk: id, status: 'CARDS_PRINTED'};
//     let url = '/maintenance/mcases/'+id+'/status';
//     authFetch('POST', url, JSON.stringify(request), null);
//   }
// );  

export const forwardToResetFileLinks = () => (
  (dispatch) => {
    dispatch({
      type: 'RESET_FILE_LINKS',
      payload: null
    });
  }
);

export const forwardToGenerateMaintenanceSerialFileMap = (id) => (
  (dispatch) => {
    let request = { casePk: id };
    let url = '/maintenance/mcases/' + id + '/serial/file';
    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: 'GENERATE_MAINTENANCE_SERIAL_FILE_MAP',
        payload: json
      });
    });
  }
);

export const forwardToGenerateMaintenanceCheckFileMap = (id) => (
  (dispatch) => {
    let request = { casePk: id };
    let url = '/maintenance/mcases/' + id + '/statistic/file';
    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: 'GENERATE_MAINTENANCE_CHECK_FILE_MAP',
        payload: json
      });
    });
  }
);

export const forwardToGenerateMaintenanceCheckFileMap2 = (id) => (
  (dispatch) => {
    let request = { casePk: id };
    let url = '/maintenance/mcases/' + id + '/statistic/file2';
    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: 'GENERATE_MAINTENANCE_CHECK_FILE2_MAP',
        payload: json
      });
    });
  }
);

export const forwardToGenerateMaintenancePriceFileMap = (id) => (
  (dispatch) => {
    let request = { casePk: id };
    let url = '/maintenance/mcases/' + id + '/price/file';
    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: 'GENERATE_MAINTENANCE_PRICE_FILE_MAP',
        payload: json
      });
    });
  }
);

export const forwardToGenerateMaintenanceSummaryFileMap = (id) => (
  (dispatch) => {
    let request = { casePk: id };
    let url = '/maintenance/mcases/' + id + '/mainprice/file';
    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: 'GENERATE_MAINTENANCE_SUMMARY_FILE_MAP',
        payload: json
      });
    });
  }
);

export const forwardToGenerateMaintenanceCardsFileMap = (id) => (
  (dispatch) => {
    let request = { casePk: id };
    let url = '/maintenance/mcases/' + id + '/cards/file';
    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: 'GENERATE_MAINTENANCE_CARDS_FILE_MAP',
        payload: json
      });
    });
  }
);

export const forwardToFindAllMcases = () => (
  (dispatch) => {
    let url = '/maintenance/mcases';
    authFetch('GET', url, null, (json) => {
      dispatch({
        type: 'FIND_ALL_MAINTENANCE_CASES',
        payload: json
      });
    });
  }
);

export const forwardToFindMcasesByYear = (year) => (
  (dispatch) => {
    let url = '/maintenance/mcases/year/' + year;
    authFetch('GET', url, null, (json) => {
      dispatch({
        type: 'FIND_ALL_MAINTENANCE_CASES',
        payload: json
      });
    });
  }
);

export const forwardToFindProcessingMcases = () => (
  (dispatch) => {
    let url = '/maintenance/mcases/status';
    let request = { criteriaStatus: ['WAITING', 'CHECKING'] };
    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: 'FIND_ALL_MAINTENANCE_CASES',
        payload: json
      });
    });
  }
);

export const forwardToFindExportingMcases = () => (
  (dispatch) => {
    let url = '/maintenance/mcases/status';
    let request = { criteriaStatus: ['CHECKED', 'EXPORTED', 'MODIFIED'] };
    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: 'FIND_ALL_MAINTENANCE_CASES',
        payload: json
      });
    });
  }
);

export const forwardToFindExportedMcases = () => (
  (dispatch) => {
    let url = '/maintenance/mcases/status';
    let request = { criteriaStatus: ['EXPORTED'] };
    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: 'FIND_ALL_MAINTENANCE_CASES',
        payload: json
      });
    });
  }
);

export const forwardToFindPrintedMcases = () => (
  (dispatch) => {
    let url = '/maintenance/mcases/status';
    let request = { criteriaStatus: ['CARDS_PRINTED'] };
    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: 'FIND_ALL_MAINTENANCE_CASES',
        payload: json
      });
    });
  }
);

export const forwardToFindPricePrintedMcases = () => (
  (dispatch) => {
    let url = '/maintenance/mcases/status';
    let request = { criteriaStatus: ['PRICE_EXPORTED'] };
    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: 'FIND_ALL_MAINTENANCE_CASES',
        payload: json
      });
    });
  }
);

export const forwardToFindMCasesDropDownMenu = (orderId) => (
  (dispatch) => {
    let url = '/maintenance/mcases/orders/' + orderId;
    authFetch('GET', url, null, (json) => {
      dispatch({
        type: 'FIND_MCASES_DROPDOWNMENU',
        payload: json
      });
    });
  }
);

export const forwardToDeleteCase = (casePk) => (
  (dispatch) => {
    let url = '/maintenance/mcases/' + casePk;
    authFetch('DELETE', url, null, (json) => {
      dispatch({
        type: 'DELETE_MCASE',
        payload: json
      });
      dispatch(forwardToFindProcessingMcases());
    });
  }
);


// WEBPACK FOOTER //
// ./src/actions/maintenanceCasesActions.js